import { Speed } from "../models/speed.model";

export const SPEEDS: Speed[] = [
  { label: "Normal", value: "normal", code: "NORMAL" },
  { label: "Slow", value: "slow", code: "SLOW" },
  { label: "Fast", value: "fast", code: "FAST" }
];

export function getSpeedByCode(code: string): Speed | undefined {
  return SPEEDS.find(speed => speed.value === code || speed.code === code);
}

export function getSpeedByName(name: string): Speed | undefined {
  return SPEEDS.find(speed => 
    speed.label.toLowerCase().includes(name.toLowerCase())
  );
}

export function getSpeedCodes(): string[] {
  return SPEEDS.map(speed => speed.value);
}

export function getSpeedNames(): string[] {
  return SPEEDS.map(speed => speed.label);
}
